import React, { useEffect, useState } from 'react';
import { ShaderGradientCanvas, ShaderGradient } from 'shadergradient-old';

const useFPS = () => {
    const [fps, setFps] = useState(60);

    useEffect(() => {
        let frameCount = 0;
        let lastTime = performance.now();
        let raf = 0;

        const loop = (now: number) => {
            frameCount++;

            if (now - lastTime >= 1000) {
                setFps(frameCount);
                frameCount = 0;
                lastTime = now;
            }

            raf = requestAnimationFrame(loop);
        };

        raf = requestAnimationFrame(loop);

        return () => cancelAnimationFrame(raf);
    }, []);

    return fps;
};

const BackgroundCanvasWithoutRadar: React.FC = () => {
    const [isReady, setIsReady] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const fps = useFPS();
    const [isLockedLowFPS, setIsLockedLowFPS] = useState(false);

    useEffect(() => {
        if (fps < 30) {
            setIsLockedLowFPS(true);
        }
    }, [fps]);

    useEffect(() => {
        const updateViewport = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        updateViewport();

        let raf1 = 0;
        let raf2 = 0;

        raf1 = requestAnimationFrame(() => {
            setIsReady(true);

            raf2 = requestAnimationFrame(() => {
                setIsVisible(true);
            });
        });

        window.addEventListener('resize', updateViewport);

        return () => {
            cancelAnimationFrame(raf1);
            cancelAnimationFrame(raf2);
            window.removeEventListener('resize', updateViewport);
        };
    }, []);

    return (
        <div
            style={{
                position: 'absolute',
                inset: 0,
                zIndex: 0,
                overflow: 'hidden',
                background: '#000',
                pointerEvents: 'none',
            }}
        >
            {isReady && (
                <div
                    style={{
                        position: 'absolute',
                        inset: 0,
                        opacity: isVisible ? 1 : 0,
                        transition: 'opacity 180ms ease',
                        pointerEvents: 'none',
                    }}
                >
                        <ShaderGradientCanvas
                            key={isMobile ? 'mobile' : 'desktop'}
                            pixelDensity={1}
                            fov={45}
                            style={{
                                width: '100%',
                                height: '100%',
                                pointerEvents: 'none',
                            }}
                        >
                            <ShaderGradient
                                animate="on"
                                brightness={1.1}
                                cAzimuthAngle={180}
                                cDistance={isMobile ? 5 : 3.2}
                                cPolarAngle={115}
                                cameraZoom={isMobile ? 1.15 : 1.2}
                                color1="#031D22"
                                color2="#031D22"
                                color3="#000000"
                                envPreset="city"
                                grain="off"
                                lightType="3d"
                                positionX={0}
                                positionY={-0.2}
                                positionZ={0}
                                range="disabled"
                                rangeEnd={40}
                                rangeStart={0}
                                reflection={0}
                                rotationX={0}
                                rotationY={0}
                                rotationZ={190}
                                shader="defaults"
                                type="waterPlane"
                                uAmplitude={0}
                                uDensity={1.1}
                                uFrequency={5.5}
                                uSpeed={0.1}
                                uStrength={2.4}
                                uTime={0.2}
                                wireframe={false}
                            />
                        </ShaderGradientCanvas>
                </div>
            )}
        </div>
    );
};

export default BackgroundCanvasWithoutRadar;